import { HUSH_NOOK_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/hushNookBackdrops';
import { stoneBiome } from '../biomeArchetypes';

/** The Hush Nook — Mallow's refuge beneath the Drowned Road. A small lived-in
 *  cellar, not an outdoor road: muted teal stone and dark timber, warm cream
 *  lantern pools at the entry shelf and Mallow's hearth, and one cool sea-glass
 *  wash behind the tide window. No celestial, clouds, weather or rays; the map
 *  is clock-exempt so the room keeps its own light. Light pools are world-
 *  anchored to the authored props in data/levels/drowned_road_hush_nook.json. */
export const HUSH_NOOK = stoneBiome({
  id: 'hush_nook',
  sky: { from: 0x0d1513, to: 0x24261e, bands: 5 },
  motes: { colors: [0xf0deb0, 0xc9b98a], count: 8, sizeMin: 2, sizeMax: 4, driftPx: 10, periodMinMs: 14000, periodMaxMs: 24000, alphaMin: 0.12, alphaMax: 0.3 },
  glow: {
    blobs: [
      // Hearth pool around the three-window lantern and Mallow's corner.
      { color: 0xffcf86, x: 690, y: 680, size: 760, alpha: 0.42 },
      { color: 0xe8a858, x: 540, y: 690, size: 560, alpha: 0.28 },
      // Entry shelf: the first warm light after the reeds.
      { color: 0xffcf86, x: 240, y: 650, size: 380, alpha: 0.2 },
      // Quiet edge shelf: a small warm spill so the room's far end is not dead.
      { color: 0xe8b56a, x: 1460, y: 600, size: 300, alpha: 0.14 },
      // Tide window: cool light from the water above the road.
      { color: 0x7fb3b0, x: 1095, y: 540, size: 320, alpha: 0.12 },
    ],
    breathe: { periodMs: 3600, min: 0.85, max: 1.1 },
  },
  lightField: { palette: [0x6c8f88, 0x4d6a64], count: 4, sizeMin: 80, sizeMax: 150, alphaMin: 0.02, alphaMax: 0.05, driftRadius: 30, periodMinMs: 15000, periodMaxMs: 25000 },
  extraLayers: [
    {
      kind: 'candle',
      anchors: [{ x: 690, y: 691 }], // lantern v2 light_core (48×62 at x690, floor 720)
      color: 0xffe3a0,
      haloColor: 0xe8a858,
      baseAlpha: 0.7,
      flickerAmp: 0.12,
      hzMin: 0.5,
      hzMax: 1.1,
      height: 18,
      width: 8,
      haloScale: 4,
      wobblePx: 0.6,
    },
  ],
  parallax: [
    { svg: HUSH_NOOK_BACKDROPS.far, shape: 'columns', color: 0x3a4b45, speed: 0.02, height: 660, alpha: 0.9, detail: 1 },
    { svg: HUSH_NOOK_BACKDROPS.mid, shape: 'columns', color: 0x3a2d20, speed: 0.04, height: 350, alpha: 0.88, detail: 1 },
    { svg: HUSH_NOOK_BACKDROPS.near, shape: 'columns', color: 0x131c1a, speed: 0.07, height: 190, alpha: 0.85, detail: 1 },
  ],
  closer: {
    vignette: { color: 0x000000, edgeAlpha: 0.5, washColor: 0x2a1a0a, washAlpha: 0.1 },
    grade: { top: 0x24261e, bottom: 0x4a3218, strength: 0.2, blend: 'normal' },
  },
});
